







































import { Component, Vue, Prop } from 'vue-property-decorator'

import CollectedDataChart from '@/components/lfs/Statistics/Items/CollectedDataChart.vue'
import CollectedDataTable from '@/components/lfs/Statistics/Items/CollectedDataTable.vue'
import Chips from '@/components/lfs/Statistics/Items/Chips.vue'

@Component({
  name: 'c-collected-data',

  components: {
    'c-collected-data-chart': CollectedDataChart,
    'c-collected-data-table': CollectedDataTable,
    'c-chips': Chips
  }
})
export default class CollectedData extends Vue {
  @Prop(Boolean) isUpdated: boolean = false

  isShow: boolean = false

  mounted () {
    this.isShow = true
  }

  get targetMyData () {
    return this.$store.getters['statistics/getTargetMyData']
  }

  get countShardsForHourVal (): { badges: number, companies: number, products: number } {
    let countVal = {
      badges: 0,
      companies: 0,
      products: 0
    }

    this.$store.getters['statistics/getShardsForHours'].forEach((elem: any) => {
      countVal.badges += elem.badges
      countVal.companies += elem.companies
      countVal.products += elem.products
    })

    return countVal
  }

  countGuests() {
    return this.$store.getters['statistics/getGuestsCount']
  }
}
